$(function(){
	$('a[href=#toTop]').click(function(){
		var speed = 500;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$("html, body").animate({scrollTop:position}, speed, "swing");
		return false;
	});
});


/*****************
 ** WEBPACK FOOTER
 ** ../common/pc/js/toTop.js
 ** module id = 2
 ** module chunks = 0
 **/